export const productShortName = 'Cement & Concrete Technology — Professional Edition';
export const productBrand = 'Cement & Concrete Technology';
export const productEdition = 'Professional Edition';
export const productImage = 'https://cdn.magicpatterns.com/uploads/1sDyAdddFyp5CBXhk1KxH1/MOCKUP_CEMENT.png';
export const productImageAlt =
  'Cement & Concrete Technology Professional Edition: six volumes covering cement manufacturing, cement chemistry and SCMs, aggregates and mix design, production and curing, concrete testing, and durability and quality control, plus five bonus resources';

export const checkoutUrl = 'https://cement-concrete-technology.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 6;
export const totalBonuses = 5;
export const bonusValue = 'USD 14.00';
export const bonusTotalValue = 'USD 70.00';

export const closingLines = [
  'No more confusion about how raw materials become clinker and cement',
  'No more uncertainty about cement types, SCMs and what they change in concrete',
  'No more guessing why a mix needs a certain w/c ratio or admixture',
  'No more gaps in understanding placing, compaction, curing and testing',
  'No more doubts when cracks, spalling or low test results appear',
];
